module.exports = __webpack_public_path__ + "img/D0001.dc871f76.svg";